module.exports = __webpack_public_path__ + "img/previous-white.a7ea943a.png";